import { Button, Clickable, Price, Strong } from '@ahmdigital/ui';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import React, { useCallback } from 'react';

import { DRAWER_IDS, PREMIUM_REVIEW_TOGGLE_STYLE } from '../../../../../../../../ahm-constants/ui';
import { ProductType } from '../../../../../../../../types/product';
import ChoosableActions from '../../../../../../../../actions/choosable';
import constants from '../../../../../../../../ahm-constants';
import Disclaimer from '../disclaimer';
import DrawerActions from '../../../../../../../../actions/drawer';
import PremiumReviewToggle from '../../../../../../../../components/premium-review-toggle-wrapper';
import PriceService from '../../../../../../../../models/price';
import ProductService from '../../../../../../../../models/product';
import selectCart from '../../../../../../../../selectors/select-cart';
import selectIsPremiumChangeEnabled from '../../../../../../../../selectors/select-is-premium-change-enabled';
import styles from './styles.module.sass';
import truncateFrequency from '../../../../utils/truncate-frequency';
import UrlService from '../../../../../../../../models/url';

const { EXTRAS, HOSPITAL } = constants.PRODUCT_TYPE;

type BundleChosenViewProps = {
  customer: {
    frequency: string;
  };
  effectiveDate?: string;
  isCondensed?: boolean;
  prices?: {};
  productId: string;
  isBundleChosen?: boolean;
};

const BundleChosenView = ({
  customer,
  effectiveDate,
  isCondensed,
  prices,
  productId,
  isBundleChosen,
}: BundleChosenViewProps) => {
  const dispatch = useDispatch();
  const isPremiumChangeEnabled = useSelector(selectIsPremiumChangeEnabled);
  const cart = useSelector(selectCart);
  const hospitalId = cart?.hospital?.id;
  let cartProductId = productId;
  if (hospitalId) {
    cartProductId = ProductService.getCombinedId(
      { id: hospitalId, type: HOSPITAL } as ProductType,
      { id: productId, type: EXTRAS } as ProductType,
    );
  }
  const productUrl = UrlService.getProductUrl(cartProductId);

  const onRefinePriceClick = useCallback(() => {
    DrawerActions.openDrawer(DRAWER_IDS.CHANGE_DETAILS)(dispatch);
  }, [dispatch]);

  const onDoneClick = useCallback(() => {
    ChoosableActions.setChoosableComparerProductId(productId)(dispatch);
    // @ts-expect-error - Automatic, Please fix when editing this file
    DrawerActions.closeDrawer(DRAWER_IDS.PICKER)(dispatch);
  }, [dispatch, productId]);
  // @ts-expect-error - Automatic, Please fix when editing this file
  const rawPrice = PriceService.getPrice(prices, productId, customer, { date: effectiveDate });
  const price = rawPrice ? PriceService.getAmountAsObject(rawPrice, customer.frequency) : null;

  const priceVariantStyles = ['inlineSpinner', styles.price, isPremiumChangeEnabled ? styles.premiumPrice : {}];

  return (
    <>
      <Disclaimer showRefineLink={!isCondensed} />
      <div className={classNames(styles.container, { [`${styles.isCondensed}`]: isCondensed })}>
        <div className={styles.priceWrapper}>
          <Price
            frequency={truncateFrequency(customer.frequency)}
            isFrequencyInline
            // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ cents: string | undefined; dollars: string | undefined; } | null' is not assignable to type '{ cents?: string | undefined; dollars?: string | undefined; } | undefined'.
            price={price}
            showAsterisk
            variant={priceVariantStyles}
          />
          {isPremiumChangeEnabled && (
            <div className={styles.premiumChangeWrapper}>
              <PremiumReviewToggle type={PREMIUM_REVIEW_TOGGLE_STYLE.READ_ONLY} />
            </div>
          )}
          {!isCondensed && (
            <Clickable onClick={onRefinePriceClick} variant={styles.refinePriceLink}>
              <Strong variant="small">Refine price</Strong>
            </Clickable>
          )}
        </div>
        {isCondensed ? (
          <Button onClick={onDoneClick} variant={[styles.doneButton, 'marginBottomSpacer11']}>
            Done
          </Button>
        ) : (
          <Button variant={['border', 'purple', styles.button]} to={productUrl}>
            {isBundleChosen ? 'View cover' : 'View teeth only'}
          </Button>
        )}
      </div>
    </>
  );
};

BundleChosenView.defaultProps = {
  effectiveDate: null,
  isCondensed: false,
  prices: {},
};

export default BundleChosenView;
